import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux'
import router from 'config/routes';
import store from 'redux/store';
import ModalDiscardChanges from 'components/ModalDiscardChanges';
import ModalOnboarding from 'components/ModalOnboarding';
import Footer from 'components/Footer';
import Toaster from 'components/Toaster';
import lizzyApi from 'lizzyApiAdapter';

function App() {
  useEffect(() => {
    lizzyApi.mount(window.lizzy);

    return () => lizzyApi.unmount();
  }, []);

  return (
    <Provider store={store}>
      <ModalDiscardChanges />
      <ModalOnboarding />
      <RouterProvider router={router} />
      <Footer />
      <Toaster />
    </Provider>
  );
}

export default App;